import { Card } from "@/components/ui/card";

interface ProgressSectionProps {
  bondingProgress: number;
  kingProgress: number;
  isLoading?: boolean;
}

const ProgressSection = ({ bondingProgress, kingProgress, isLoading = false }: ProgressSectionProps) => {
  return (
    <div className="mt-4 space-y-2">
      <div className="bg-white/5 p-2 rounded">
        <div className="flex justify-between text-sm">
          <span>bonding curve progress:</span>
          <span>{isLoading ? "—" : `${bondingProgress.toFixed(1)}%`}</span>
        </div>
        <div className="w-full bg-green-500 h-1 rounded mt-1" 
          style={{ width: `${bondingProgress}%` }} 
        />
      </div>

      <div className="bg-white/5 p-2 rounded">
        <div className="flex justify-between text-sm">
          <span>king of the bots progress:</span>
          <span>{isLoading ? "—" : `${kingProgress.toFixed(1)}%`}</span>
        </div>
        <div className="w-full bg-yellow-500 h-1 rounded mt-1" 
          style={{ width: `${kingProgress}%` }} 
        />
      </div>
    </div>
  );
};

export default ProgressSection;
